import {Injectable} from '@angular/core';
import {Store} from "@ngrx/store";
import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface";
import {USER_ACTIONS} from "@ispm/user/store/user-actions.constant";

@Injectable()
export class UsersStoreHandler {

  private usersStore$: any;
  constructor(store: Store<IgenomicsState>) {
    this.usersStore$ = store.select('users');
  }

  public setCurrentUser(value?: any): void {
    this.usersStore$.dispatch({
      type: USER_ACTIONS.SET_CURRENT_USER,
      payload: value
    });
  }


}
